import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ping',
    templateUrl: './ping.component.html',
    styleUrls: ['./ping.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export default class PingComponent implements OnInit {
  // SonarQube does not like empty constructors:
  constructor() {
    /* TODO document why this constructor is empty */
  }

  ngOnInit(): void {
    /* TODO document why this method 'ngOnInit' is empty */
  }
}
